var $241bc0bbd870e982$exports = {};
$241bc0bbd870e982$exports = {
  "decrease": function decrease(args) {
    return "Zmniejsz ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Zwi\u0119ksz ".concat(args.fieldLabel);
  },
  "numberField": "Pole numeru"
};
export { $241bc0bbd870e982$exports as default };